import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { ModalMobile as Modal } from '@alfalab/core-components-modal/mobile';

import { Content as Component } from '../content';
import type { TContentProps, IContentDeps } from '../models';
import styles from '../../../modal/mobile/mobile.css';

export const ModalV2ContentMobile = createWidget<IContentDeps, TContentProps>({
    Modal,
    styles,
})(Component);
